import { createApiClient } from "../config/ApiConfig";

const API = createApiClient(`${process.env.REACT_APP_BACKEND_URI}/api/notifications`);

// GET NOTIFICATIONS FOR EMPLOYEE
export const getNotifications = async () => {
    const response = await API.get("/");
    return response.data;
};

// GET UNREAD COUNT
export const getUnreadCount = async () => {
    const response = await API.get("/unread-count");
    return response.data.count;
};

// MARK SINGLE NOTIFICATION AS READ
export const markNotificationRead = async (notificationId) => {
    const response = await API.patch(`/${notificationId}/read`);
    return response.data;
};

// MARK ALL NOTIFICATIONS AS READ
export const markAllNotificationsRead = async () => {
    const response = await API.patch("/read-all");
    return response.data;
};

export default API;
